import React from 'react';
import { motion } from 'framer-motion';

const VenueRules = ({ cards }) => {
    if (!cards || cards.length === 0) return null;

    return (
        <section className="py-16 sm:py-20 px-4 bg-white">
            <div className="max-w-7xl mx-auto">
                {/* Десктопная версия: два столбца */}
                <div className="hidden lg:grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                    {/* Левая гифка */}
                    <motion.div
                        className="relative h-[500px] lg:h-[650px] rounded-3xl overflow-hidden shadow-2xl"
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                    >
                        <img
                            src="/images/venue-rules.gif"
                            alt="Площадка"
                            className="absolute inset-0 w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent" />
                    </motion.div>

                    {/* Правая колонка*/}
                    <div className="space-y-6">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                        >
                            <h2 className="text-4xl md:text-5xl font-display mb-3">
                                Правила площадки
                            </h2>
                            <p className="text-gray-600 text-lg">
                                Просим ознакомиться с важными правилами, чтобы наш праздник прошёл комфортно для всех
                            </p>
                        </motion.div>

                        <div className="space-y-4">
                            {cards.map((card, index) => (
                                <motion.div
                                    key={card.id}
                                    className="bg-gray-50 border border-gray-100 rounded-2xl p-6 hover:shadow-md transition-shadow"
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: index * 0.05 }}
                                >
                                    <h3 className="text-xl font-medium mb-3 flex items-center gap-3">
                                        <span className="text-2xl">•</span>
                                        {card.title}
                                    </h3>
                                    <p className="text-gray-600 leading-relaxed">
                                        {card.content}
                                    </p>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Мобильная версия: заголовок → гифка → карточки */}
                <div className="lg:hidden flex flex-col gap-8">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                    >
                        <h2 className="text-4xl md:text-5xl font-display mb-3">
                            Правила площадки
                        </h2>
                        <p className="text-gray-600 text-lg">
                            Просим ознакомиться с важными правилами, чтобы наш праздник прошёл комфортно для всех
                        </p>
                    </motion.div>

                    <motion.div
                        className="relative h-[300px] sm:h-[400px] rounded-3xl overflow-hidden shadow-2xl"
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                    >
                        <img
                            src="/images/venue-rules.gif"
                            alt="Площадка"
                            className="absolute inset-0 w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent" />
                    </motion.div>

                    <div className="space-y-4">
                        {cards.map((card, index) => (
                            <motion.div
                                key={card.id}
                                className="bg-gray-50 border border-gray-100 rounded-2xl p-6 hover:shadow-md transition-shadow"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.05 }}
                            >
                                <h3 className="text-xl font-medium mb-3 flex items-center gap-3">
                                    <span className="text-2xl">•</span>
                                    {card.title}
                                </h3>
                                <p className="text-gray-600 leading-relaxed">
                                    {card.content}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VenueRules;